import {Dialog, type DialogButtonProps, type DialogProps} from '@primer/react/experimental'
import {type PropsWithChildren, useCallback} from 'react'

import styles from './RelationshipsAlertDialog.module.css'

const SingleConfirmBody = ({children}: PropsWithChildren<DialogProps>) => <div className={styles.body}>{children}</div>

const SingleConfirmFooter: React.FC<DialogProps> = ({footerButtons}) => (
  <div className={styles.footer}>
    <Dialog.Buttons buttons={footerButtons ?? []} />
  </div>
)

export interface RelationshipsAlertDialogProps {
  title: string
  children?: React.ReactNode
  width?: DialogProps['width']
  onClose: (gesture: 'confirm' | 'close-button' | 'escape') => void
}

export function RelationshipsAlertDialog({
  title,
  children,
  onClose,
  width = 'medium',
  ...rest
}: RelationshipsAlertDialogProps) {
  const confirmButton: DialogButtonProps = {
    buttonType: 'primary',
    content: 'OK',
    onClick: useCallback(() => onClose('confirm'), [onClose]),
  }

  return (
    <Dialog
      title={title}
      role="alertdialog"
      width={width}
      onClose={onClose}
      footerButtons={[confirmButton]}
      renderBody={SingleConfirmBody}
      renderFooter={SingleConfirmFooter}
      {...rest}
    >
      {children}
    </Dialog>
  )
}
